import React, { FC } from 'react';

import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';
import { SessionViews } from 'src/common/types/WfaSessionViews';

import { MfaSessionAllIssues } from './all-issues/MfaSessionAllIssues';
import { MfaSessionOverview } from './overview/MfaSessionOverview';
import { MfaSessionScans } from './scans';

interface IMfaSingleSessionTabContentProps {
	viewId: SessionViews;
	sessionId: string;
}

export const MfaSingleSessionTabContent: FC<IMfaSingleSessionTabContentProps> = ({
	viewId,
	sessionId
}) => {
	const { configuration } = useConfiguration();
	const showScansTab = configuration?.PLATFORM?.DEV_TOGGLES?.ENABLE_MOBILE_SCANS_VIEW ?? false;

	switch (viewId) {
		case SessionViews.OVERVIEW: {
			return <MfaSessionOverview sessionId={sessionId} />;
		}

		case SessionViews.ALL_ISSUES: {
			return <MfaSessionAllIssues sessionId={sessionId} />;
		}

		case SessionViews.SCANS: {
			return showScansTab ? <MfaSessionScans sessionId={sessionId} /> : null;
		}

		default:
			return null;
	}
};
